// Copyright (c) 2023 by Move Closer

import { CanBeAlignedHorizontally, ImageData, Module, ModuleContent, Related } from '../../contexts'

import { AvailableModuleDriver } from '../allowed'
import { ResolvedLink, UnresolvedLink } from '../partials'
import { CTABoxSection } from '../CTABox/CTABox.contracts'

/**
 * @author Katarzyna Otto <katarzyna.otto@movecloser.pl>
 */
export enum Separators {
  Default = 'default',
  Line = 'line',
  Dots = 'dots'
}

/**
 * @author Katarzyna Otto <katarzyna.otto@movecloser.pl>
 */
export type InfoCardModule = Module<InfoCardModuleContent, AvailableModuleDriver.InfoCard>

/**
 * @author Katarzyna Otto <katarzyna.otto@movecloser.pl>
 */
export interface InfoCardModuleData extends CanBeAlignedHorizontally {
  /**
   * picture on the left side of the box
   */
  imageLeft?: ImageData | null

  /**
   * picture on the right side of the box
   */
  imageRight?: ImageData | null

  /**
   * CTA section.
   */
  cta?: InfoCardSection

  /**
   * Description.
   */
  content: string

  /**
   * Headline.
   */
  headline: string

  /**
   * Additional information.
   */
  additionalInfo: string

  /**
   * Separator type.
   */
  separator: Separators | null
}

/**
 * @author Katarzyna Otto <katarzyna.otto@movecloser.pl>
 */
export type InfoCardModuleContent = InfoCardModuleData & ModuleContent

/**
 * @author Katarzyna Otto <katarzyna.otto@movecloser.pl>
 */
export interface InfoCardSection {
  /**
   * CTA link.
   */
  action?: ResolvedLink
}

/**
 * @author Katarzyna Otto <katarzyna.otto@movecloser.pl>
 */
export interface InfoCardModuleContentInput extends ModuleContent {
  /**
   * Unresolved cta's link
   */
  cta?: Omit<CTABoxSection, 'action'> & { action: UnresolvedLink | null }

  /**
   * Unresolved image
   */
  imageLeft: Related

  /**
   * Unresolved image
   */
  imageRight: Related

  /**
   * Unresolved headline
   */
  headline: string

  /**
   * Unresolved content
   */
  content: string

  /**
   * Unresolved additional info
   */
  additionalInfo: string

  /**
   * Separator
   */
  separator: Separators
}
